import React, { lazy, memo } from 'react';
import { motion } from 'framer-motion';
import { haptics } from '../../lib/utils/haptics';
export const TopOffers = memo(function TopOffers() {
  const topOffers = [{
    title: 'Buy 1 Get 1 Free',
    img: 'https://cdn-icons-png.flaticon.com/512/6145/6145750.png'
  }, {
    title: '50% Off',
    img: 'https://cdn-icons-png.flaticon.com/512/15106/15106141.png'
  }, {
    title: '1 SAR Deal',
    img: 'https://cdn-icons-png.flaticon.com/512/15106/15106181.png'
  }, {
    title: 'Panda Offers',
    img: 'https://cdn-icons-png.flaticon.com/512/10473/10473619.png'
  }, {
    title: 'Cashback',
    img: 'https://cdn-icons-png.flaticon.com/128/6145/6145812.png'
  }, {
    title: 'Flash Sale',
    img: 'https://cdn-icons-png.flaticon.com/512/6145/6145802.png'
  }, {
    title: 'Weekend Specials',
    img: 'https://cdn-icons-png.flaticon.com/512/6145/6145620.png'
  }, {
    title: 'Online Exclusive',
    img: 'https://cdn-icons-png.flaticon.com/128/15106/15106115.png'
  }, {
    title: 'New Arrivals',
    img: 'https://cdn-icons-png.flaticon.com/512/6145/6145753.png'
  }, {
    title: 'Free Shipping',
    img: 'https://cdn-icons-png.flaticon.com/512/6145/6145698.png'
  }];
  return <div className="container mx-auto px-4" data-id="element-2643" data-mp="2p29kv7elfiqr">
      <div className="mb-6" data-id="element-2644" data-mp="3cr2l3g290cr6">
        <h2 className="text-2xl font-bold mb-4" data-id="element-2645" data-mp="3cqst5mxn7viu">Top Offers</h2>
        {/* Desktop View */}
        <div className="hidden md:grid md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 gap-3" data-id="element-2646" data-mp="3hqowrl2fhkxv">
          {topOffers.map((offer, index) => <motion.a key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.03,
          duration: 0.4
        }} onClick={() => haptics.impact()} href="#" className="flex flex-col items-center group cursor-pointer" data-id="element-2647" data-mp="330q0xoycillk" data-mpi={index}>
              <div className="relative w-full aspect-square rounded-2xl overflow-hidden bg-gray-50 mb-2 group-hover:shadow-lg transition-all" data-id="element-2648" data-mp="55i8gnblkipm">
                <img src={offer.img} alt={offer.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" loading="lazy" decoding="async" data-id="element-2649" data-mp="9t2o28zi5kv" />
              </div>
              <span className="text-xs lg:text-sm font-bold text-center text-gray-900 group-hover:text-[#1E2B55] transition-colors" data-id="element-2650" data-mp="3dmd016my2goe">
                {offer.title}
              </span>
            </motion.a>)}
        </div>
        {/* Mobile View */}
        <div className="md:hidden -mx-4" data-id="element-2651" data-mp="33op4iehil556">
          <div className="overflow-x-auto scrollbar-hide px-4" data-id="element-2652" data-mp="1j64t0rni4vum">
            <div className="flex gap-4 pb-2" data-id="element-2653" data-mp="1j5wgx1z7dukh">
              {topOffers.map((offer, index) => <motion.a key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.03,
              duration: 0.4
            }} onClick={() => haptics.impact()} href="#" className="flex flex-col items-center flex-shrink-0 w-24 active:scale-95 transition-transform" data-id="element-2654" data-mp="1o3efpzjiater" data-mpi={index}>
                  <div className="relative w-24 h-24 rounded-2xl overflow-hidden bg-gray-50 mb-2 shadow-sm" data-id="element-2655" data-mp="howzr50kmpjk">
                    <img src={offer.img} alt={offer.title} className="w-full h-full object-cover" loading="lazy" decoding="async" width="96" height="96" data-id="element-2656" data-mp="lonz3x45ydzp" />
                  </div>
                  <span className="text-xs font-bold text-center text-gray-900 line-clamp-2" data-id="element-2657" data-mp="7kyopwntkuza">
                    {offer.title}
                  </span>
                </motion.a>)}
            </div>
          </div>
        </div>
      </div>
      <style jsx data-id="element-2658" data-mp="gfmurp17ygp5">{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
});